/* unplugin-vue-components disabled */import script from "./ChannelCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelCard.vue?vue&type=script&setup=true&lang=js"

import "./ChannelCard.vue?vue&type=style&index=0&id=732653c9&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732653c9"]])

export default __exports__